import styled from 'styled-components';
import { H1, P } from '../elements/Text';

import { EmptyDiv } from './common';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 720px;
  margin: 0 auto;
  padding-bottom: 72px;
  height: 100%;
  padding: 0 16px;
  /* margin-top: 72px; */
  /* margin-bottom: 72px; */
`;

export default function TestOutro() {
  return (
    <Wrapper>
      <H1 style={{ marginTop: 32 }}>Well done! 🎉</H1>
      <P>You've successfully completed the assessment.</P>
      <P>
        We appreciate the effort you've put into providing detailed responses.
      </P>
      <P>
        <b>Your answers have been saved and submitted for review.</b>
      </P>
      <P>
        Our assessment team will now evaluate your responses. You'll receive
        your results and recommended next steps within the next few days.
      </P>
      <EmptyDiv height={75} />
    </Wrapper>
  );
}
